import { array, enum as zEnum, number, object, string } from 'zod';

import { isGreaterThanOrEqualTo } from '@occc-app/lib/constants/validationMessages';
import { withIsEnabled } from '@occc/validation';

import { TRANSACTION_FREQUENCY_MAX_ROWS } from './transaction-frequency-limit.constants';

const TRANSACTION_FREQUENCY_WHEN_ENABLED_MESSAGE =
  'At least one limit is required when the section is enabled';

export const TRANSACTION_FREQUENCY_NO_DUPLICATE_PERIODS_MESSAGE =
  'Duplicate time periods are not allowed';

export const transactionFrequencyTimePeriodSchema = zEnum(['TOTAL', 'DAY', 'WEEK', 'MONTH']);

export const transactionFrequencyLimitRowSchema = object({
  id: string().optional(),
  limit: number({ required_error: isGreaterThanOrEqualTo(1) })
    .int()
    .min(1, isGreaterThanOrEqualTo(1)),
  timePeriod: transactionFrequencyTimePeriodSchema,
});

const TransactionFrequencyEnabledSchema = object({
  rows: array(transactionFrequencyLimitRowSchema)
    .min(1, TRANSACTION_FREQUENCY_WHEN_ENABLED_MESSAGE)
    .max(TRANSACTION_FREQUENCY_MAX_ROWS)
    .superRefine((rows, ctx) => {
      const seen = new Set<string>();
      rows.forEach((row, i) => {
        if (seen.has(row.timePeriod)) {
          ctx.addIssue({
            code: 'custom',
            message: TRANSACTION_FREQUENCY_NO_DUPLICATE_PERIODS_MESSAGE,
            path: [i, 'timePeriod'],
          });
        } else {
          seen.add(row.timePeriod);
        }
      });
    }),
});

const TransactionFrequencyDisabledSchema = object({}).passthrough();

export const transactionFrequencyLimitSchema = withIsEnabled(
  TransactionFrequencyEnabledSchema,
  TransactionFrequencyDisabledSchema,
).optional();

export const transactionFrequencyLimitFormSchema = transactionFrequencyLimitSchema;
